import login from '@/api/loginApi';
import systemUser from '@/api/systemUserApi';
import accredit from '@/api/openPortApi';
import wholeNetworkApi from '@/api/wholeNetworkApi';

export default{
    login,
    systemUser,//系统管理
    accredit,//统计
    wholeNetworkApi,//全网
};



// WEBPACK FOOTER //
// ./src/api/index.js